<template>
  <div class="container">
    <div v-if="message.visible" class="alert fade show" v-bind:class="messageStyle" role="alert"
         style="margin-top:20px;margin-bottom: 20px" id="message_popup">
      {{message.content}}
      <button type="button" class="close" @click="closeMessage" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import {HIDE_MESSAGE} from "../store/actions";

  export default {
    name: "Message",
    computed: {
      ...mapGetters(['message', 'messageStyle'])
    },
    methods: {
      closeMessage: function () {
        this.$store.dispatch({
          type: HIDE_MESSAGE
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Message.vue